<!-- 页脚 -->
<!-- 页脚 -->
<template>
  <div class="ele-text-center" style="padding: 16px 0;">
   
  </div>
</template>


<script>
export default {
  name: 'EleFooter'
}
</script>
